<template>
  <div>
    <b-modal
      id="modal-edit"
      size="lg"
      centered
      :title="$store.state.modal.editPengajuanLembur"
      header-bg-variant="primary"
      header-text-variant="light"
    >
      <b-form>
        <b-form-group label="Karyawan" label-cols-md="3">
          <multiselect
            :state="checkIfValid('karyawan')"
            v-model="$v.data.karyawan.$model"
            :disabled="false"
            :options="listKaryawan"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Karyawan --"
            label="namaKaryawan"
            track-by="id"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Lembur" label-cols-md="3">
          <multiselect
            :state="checkIfValid('lembur')"
            v-model="$v.data.lembur.$model"
            :disabled="false"
            :options="listMasterLembur"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            placeholder="-- Pilih Lembur --"
            label="namaLembur"
            track-by="id"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Tanggal Lembur" label-cols-md="3">
          <date-picker 
            style="width: 100%"
            :state="checkIfValid('tanggalPengajuanLembur')"
            v-model="$v.data.tanggalPengajuanLembur.$model"
          ></date-picker>
        </b-form-group>
        <b-form-group label="Lembur (jam)" label-cols-md="3">
          <b-form-select
            :options="optionsJam"
            :state="checkIfValid('jumlahJamLembur')"
            v-model="$v.data.jumlahJamLembur.$model"
          ></b-form-select>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{$store.state.form.batal}}
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy || !isValid"
          @click="simpan()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
export default {
  name: "modalInput",
  props: ["data", "listMasterLembur", 'listKaryawan', 'optionsJam'],
  data() {
    return {
      busy: false,
      button: "Simpan"
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      karyawan: { required },
      lembur: { required },
      tanggalPengajuanLembur: { required },
      jumlahJamLembur: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = this.$store.state.form.tunggu;
        vm.data.dataKaryawanId = vm.data.karyawan.dataKaryawanId;
        vm.data.masterLemburId = vm.data.lembur.id;
        vm.data.id = vm.data.pengajuanLemburId;
        vm.$axios
          .post("pengajuanLembur/update", vm.data)
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = this.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH MASTER ASURANSI",
                showing: true,
              });
              this.$v.$reset()
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = this.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = this.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch:{
    lang:function(val){
      val
      this.button = this.$store.state.form.simpan
    }
  }
};
</script>
